/**
* Mobile Navigation Drawer
*/
class MobileNavigation extends HTMLElement {
  constructor() {
    super();
    
    this.touchstartX = 0;
    this.touchendX = 0;

    this.openeBy = document.querySelector('#mobile-menu');
    this.closeBy = document.querySelector('.close-mobile--navbar');
    this.navDrawer = this.querySelector('#mobile-menu-drawer');
    this.bindEvents();
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(event){
    let isOpen = this.navDrawer.classList.contains('opened-drawer');
    if (!this.contains(event.relatedTarget) && isOpen == true) {
      this.closeBy.dispatchEvent(new Event('click'));
    }
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if(event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    this.closeBy.dispatchEvent(new Event('click'));
  }

  /**
   * bind click event to Menu Icon 
   * bind keyup event to Menu Drawer component
   */
  bindEvents() {
    this.openeBy.addEventListener('click', this.openMenuDrawer.bind(this));
    this.closeBy.addEventListener('click', this.closeMenuDrawer.bind(this));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
  }

  /**
   * Open Menu Drawer
   *
   * @param {event} Event instance
   */
  openMenuDrawer(event) {
    event.preventDefault();
    this.navDrawer.classList.add('opened-drawer');
    document.body.classList.add('menu-search-open');
    siteOverlay.prototype.showOverlay();
    if(document.querySelector('cart-form.cart-drawer').classList.contains('opened-drawer')){
      document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }
    if(event){
      // event.preventDefault();
      let openBy = event.currentTarget;
      openBy.setAttribute('aria-expanded', true);
      event.currentTarget.classList.add('d-none')
      this.closeBy.classList.remove('d-none')
      
      // Utility.trapFocus(this.navDrawer, this.querySelector('.mobile-header--logo'));
      // Utility.forceFocus(this.querySelector('.mobile-header--logo'));
    }
  }

  /**
   * Close Menu Drawer
   *
   * @param {event} Event instance
   */
  closeMenuDrawer(event, elementToFocus = false) {
    event.preventDefault();
    if (event !== undefined) {
      this.navDrawer.classList.remove('opened-drawer');
      document.body.classList.remove('menu-search-open');
      siteOverlay.prototype.hideOverlay();
      let openDropdowns = Array.from(document.querySelectorAll('#mobile-menu-drawer .dropdown.open'));
      openDropdowns.forEach((ele) => {
        ele.classList.remove('open');
        ele.querySelector('.dropdown-menu')?.classList.remove('open');
        ele.querySelector('[is="drop-down"]').setAttribute('aria-expanded', false);
      });
      event.currentTarget.classList.add('d-none')
      this.openeBy.classList.remove('d-none')
      this.openeBy.setAttribute('aria-expanded', false);
      Utility.forceFocus(this.openeBy);
    }
  }

  /**
   * To get User Touch action pattern (Swipe Left / Swipe Right)
   *
   */
  handleGesture() {
    if (this.touchendX < this.thistouchstartX)
      this.openeBy.dispatchEvent(new Event('click'));
    if (this.touchendX > this.touchstartX)
      this.closeBy.dispatchEvent(new Event('click'));
  }
}
customElements.define("mobile-nav", MobileNavigation);

let gTranslatorDesktop = document.querySelector('#google_language_translator');
let gTranslatorMobile = document.querySelector('#google_language_translator_mobile');


/**
 * Mobile google translator functionality
 */
function mobileTranslateDiscpatch() {
  let gTranslatorDesktopSelection = document.querySelector('#google_language_translator select');
  let gTranslatorMobileSelection = document.querySelector('#google_language_translator_mobile select');
  gTranslatorMobileSelection.value = gTranslatorDesktopSelection.value;
  gTranslatorMobileSelection.addEventListener('change', (e) => {
    e.preventDefault();
    let value = e.currentTarget.value;
    gTranslatorDesktopSelection.value = value;
    gTranslatorDesktopSelection.dispatchEvent(new Event('change'));
  })
}
let googleTranslatorMobile = new MutationObserver(entries => {
  entries.forEach(entry => {
    if (entry.addedNodes.length > 0) {
      let desktopSelect = gTranslatorDesktop.querySelector('select');
      let mobileSelect = gTranslatorMobile.querySelector('select');
      if (mobileSelect) {
        mobileSelect.replaceWith(desktopSelect.cloneNode(true));
      } else {
        gTranslatorMobile.appendChild(desktopSelect.cloneNode(true));
      }
    }
    mobileTranslateDiscpatch()
  });
});

googleTranslatorMobile.observe(gTranslatorDesktop, { childList: true, subtree: true });